// src/feedbackreports/CategoryAnalysis.js
import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import "./categoryanalysis.css";

const CategoryAnalysis = ({ userId }) => {
  const [analysis, setAnalysis] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!userId) {
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);
    fetch(`/api/admin/category-analysis/${userId}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        setAnalysis(data.categoryAnalysis || []);
      })
      .catch((err) => {
        console.error("Error fetching analysis:", err);
        setError("Failed to fetch data. Please try again later.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [userId]);

  if (isLoading) {
    return (
      <div className="text-center py-20">
        <p className="text-lg text-gray-600">Loading analysis...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-20">
        <p className="text-lg text-red-500">{error}</p>
      </div>
    );
  }

  if (analysis.length === 0) {
    return (
      <div className="text-center py-20">
        <p className="text-lg text-gray-500 italic">No feedback submitted yet</p>
      </div>
    );
  }

  return (
    // <div className="bg-gray-100 min-h-screen p-8">
      // <div className="max-w-7xl mx-auto">
        // <div className="category-analysis-container">
        //<h2 className="analysis-title">
          //Feedback Analysis
        //</h2>

        <div className="category-card-container">
          {analysis.map((cat, idx) => {
            const chartData = [
              {
                name: "Ratings",
                Self: cat.Self ? Number(cat.Self) : null,
                Peer: cat.Peer ? Number(cat.Peer) : null,
                Manager: cat.Manager ? Number(cat.Manager) : null,
                Reportee: cat.Reportee ? Number(cat.Reportee) : null,
              },
            ];

            return (
              <div key={idx} className="category-card bg-white rounded-xl shadow-lg p-6">
                <h3 className="category-title text-center mb-4">{cat.category}</h3>
            <ResponsiveContainer width="100%" height={200}>
                  <BarChart
                    data={chartData}
                    margin={{ top: 20, right: 20, left: 0, bottom: 40 }}
                  >
                    <XAxis dataKey="name" hide /> {/* hide X label "Ratings" */}
                    <YAxis domain={[0, 5]} />
                    <Tooltip />
                  <Legend  layout="vertical" verticalAlign="bottom" height={36} wrapperStyle={{ top: '100%', transform: 'translateY(-60px)' }} /> {/* legend below bars */}

                    <Bar dataKey="Self" fill="#9e58ff" radius={[10, 10, 0,0]}>
                      <LabelList dataKey="Self" position="top" style={{ fontSize: '12px' ,fontWeight: 'bold' }} />
                    </Bar>
                    <Bar dataKey="Peer" fill="#fe9496" radius={[10, 10, 0, 0]}>
                      <LabelList dataKey="Peer" position="top" style={{ fontSize: '12px',fontWeight: 'bold'  }} />
                    </Bar>
                    {cat.Manager && (
                      <Bar dataKey="Manager" fill="#ffc107" radius={[10, 10, 0, 0]}>
                        <LabelList dataKey="Manager" position="top" style={{ fontSize: '12px' ,fontWeight: 'bold' }}/>
                      </Bar>
                    )}
                    <Bar dataKey="Reportee" fill="#4Bcbeb" radius={[10, 10, 0, 0]}>
                      <LabelList dataKey="Reportee" position="top" style={{ fontSize: '12px',fontWeight: 'bold' }}/>
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            );
          })}
        </div>
      //</div>
    //</div>
  );
};

export default CategoryAnalysis;
